import React from 'react';

function NumberToWords({ number }) {
  const convertNumberToWords = (num) => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if (num === 0) return 'zero';

    const convertChunkToWords = (chunk) => {
      let result = '';

      const hundredsDigit = Math.floor(chunk / 100);
      const tensDigit = Math.floor((chunk % 100) / 10);
      const unitsDigit = chunk % 10;

      if (hundredsDigit !== 0) {
        result += units[hundredsDigit] + ' Hundred ';
      }

      if (tensDigit === 1) {
        result += tens[unitsDigit] + ' ';
      } else {
        result += tens[tensDigit] + ' ' + units[unitsDigit] + ' ';
      }

      return result.trim();
    };

    let words = '';
    let chunkCount = 0;

    while (num > 0) {
      const chunk = num % 1000;
      if (chunk !== 0) {
        const chunkWords = convertChunkToWords(chunk);

        if (chunkCount > 0) {
          words = chunkWords + getScaleWord(chunkCount) + ' ' + words;
        } else {
          words = chunkWords;
        }
      }
      num = Math.floor(num / 1000);
      chunkCount++;
    }

    return words.trim();
  };

  const getScaleWord = (chunkCount) => {
    const scales = ['', ' Thousand', 'million', 'billion', 'trillion'];
    return scales[chunkCount];
  };

  const words = convertNumberToWords(number);

  return <div >{words}</div>;
}

export default NumberToWords;
